<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :meta="meta"
        :edit.sync="edit"
        :StuffToEatDetails="StuffToEatDetails">
        <div class="content-header-item" slot="edit">
          <permissions-control-wrapper
             action="label.edit"
            :required-general="$PERMISSIONS_GENERAL.EDIT"
            :permissions="_get(StuffToEatDetails, 'meta.permissions')">
            <edit-lock-button slot="allowed" :edit.sync="edit"></edit-lock-button>
            <edit-lock-button slot="not-allowed" :lock="true"></edit-lock-button>
          </permissions-control-wrapper>
        </div>
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">
      <page-labels-popover
         v-if="showPageLabelsPopover"
        :id="id"
        :type="entityType"
        :permissions="_get(StuffToEatDetails, 'meta.permissions')"
        :servingSizeID="servingSizeID"
        @close="handleClosePageLabelsPopover">
      </page-labels-popover>

      <nuttrema-loader v-if="StuffToEatContents.fetching"></nuttrema-loader>

      <nuttrema-empty-result
        v-else-if="_isEmpty(StuffToEatContents.data)"
        slot="central"
        class="with-logo"
        predefined-set="landscape">
      </nuttrema-empty-result>

      <nuttrema-layout-schedules
         v-else
         width-east="20em"
         theme="dc-logo"
         min-width-east="2em"
        :showEast="true"
        :showWest="false">

        <template slot="east">
          <nuttrema-loader v-if="StuffToEatNutritionFacts.fetching && !StuffToEatNutritionFacts.ready"></nuttrema-loader>
          <div v-else class="section-nutrition-information">
            <div
              v-if="setManually"
              class="section-manually">
              <el-popover
                width="257"
                trigger="hover"
                placement="top-start"
                popper-class="el-popover--fix-break">
                <span>{{ $t('label.recalculate_nutrition_information_note') }}</span>
                <template slot="reference">
                  <el-button
                     class="w-100"
                    :loading="StuffToEatNutritionFacts.saving"
                    :type="setManually ? 'nuttrema-orange' : 'info'"
                    @click="onChangeManualControl">
                    {{ $t('label.turn_off_manual_entry') }}</strong>
                  </el-button>
                </template>
              </el-popover>
            </div>

            <div class="section-nutrition-facts">
              <nutrition-facts
                 mode="select-serving-size"
                 v-loading="StuffToEatNutritionFacts.fetching"
                 element-loading-background="rgba(255,255,255, 0.25)"
                 class="is-extra-pt-075"
                :showDownload="true"
                :productNutritionFacts="StuffToEatNutritionFacts.data"
                :permissions="_get(StuffToEatDetails, 'meta.permissions')"
                @downloadPDF="onDownloadPDF"
                @servingSizeChange="onServingSizeChange">
              </nutrition-facts>
            </div>

          </div>

        </template>
        <!-- end ~ east -->

        <template slot="east-fold">
          <div class="vertical-fold-content">
            <p>{{ $t('label.nutrition_facts') }}</p>
          </div>
        </template>

        <template slot="central">
          <contents-list
            :meta="meta"
            :edit="edit"
            :note="note"
            :StuffToEatContents="StuffToEatContents"
            @edit="onEditEvent">
          </contents-list>
        </template>

      </nuttrema-layout-schedules>
    </template>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

<script>
/* eslint-disable object-shorthand */
import { get } from 'lodash';
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';
import PageLabelsPopover from 'components/pages/professional/stuff-to-eat/shared/details/labels/page-labels-popover';

import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';

import NuttremaLayoutSchedules from 'components/ui/layout/nuttrema-layout-schedules';

import NutritionFacts from 'components/ui/nutrition-information/nutrition-facts';

import ContentsList from './cmpt-contents-list';

export default {
  name: 'page-stuff-to-eat-contents',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
    entityType: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
      showWest: true,
      showPageLabelsPopover: false,
    };
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
    StuffToEatContents() {
      return this.$store.getters.StuffToEatContents(this.id);
    },
    StuffToEatNutritionFacts() {
      return this.$store.getters.StuffToEatNutritionFacts(this.id);
    },
    setManually() {
      return get(this.StuffToEatDetails, 'data.manual_nutrition', false);
    },
    note() {
      let note = null;

      const manualNutrition = get(this.StuffToEatDetails, 'data.manual_nutrition', false);
      const manualAllergens = get(this.StuffToEatDetails, 'data.manual_allergens', false);

      if (manualNutrition) note = `${this.$t('label.recalculate_nutrition_information_note')}`;
      if (manualAllergens) note = note ? `${note}\n${this.$t('label.recalculate_allergens_note')}` : `${this.$t('label.recalculate_allergens_note')}`;

      return note;
    },
  },
  components: {
    ContentsList,
    NutritionFacts,
    PageLabelsPopover,
    NuttremaLayoutContent,
    NuttremaLayoutSchedules,
    StuffToEatStandardHeader,
  },
  methods: {
    ...mapActions([
      'RecreateStuffToEatNutritionFacts',
    ]),
    fetchDishData() {
      this.$store.dispatch('GetStuffToEatContents', { id: this.id, type: this.entityType });
      this.$store.dispatch('GetStuffToEatNutritionFacts', { id: this.id, type: this.entityType });
    },
    handleToggleWest() {
      this.showWest = !this.showWest;
    },
    onServingSizeChange(servingSizeID) {
      this.$store.dispatch('GetStuffToEatNutritionFacts', {
        id: this.id,
        type: this.entityType,
        servingSizeID,
      });
    },
    // onDownloadPDF(servingSizeID, action) {
    //   this.$store.dispatch('GetStuffToEatNutritionFacts', {
    //     id: this.id,
    //     type: this.entityType,
    //     servingSizeID,
    //     fileFormat: 'pdf',
    //   })
    //   .then((file) => {
    //     if (action === 'download') {
    //       const blob = new Blob([file], { type: 'application/pdf' });
    //       const fileName = `${this.$t('label.nutrition_facts_file_name', { id: this.id, serving_size: servingSizeID })}.pdf`;
    //       FileSaver.saveAs(blob, fileName);
    //     } else {
    //       const fileURL = URL.createObjectURL(file);
    //       window.open(fileURL);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
    // },
    onDownloadPDF(servingSizeID) {
      this.servingSizeID = servingSizeID;
      this.showPageLabelsPopover = true;
    },
    handleClosePageLabelsPopover() {
      this.servingSizeID = null;
      this.showPageLabelsPopover = false;
    },
    onEditEvent(sequence) {
      this.$store.dispatch('UpdateStuffToEatContentSequence', {
        id: this.id,
        type: this.entityType,
        payload: {
          sequence,
        },
      })
      .catch(() => {
        this.errorNotification();
      });
    },
    handleCommand(command) {
      switch (command) {
        case 'download':
        default:
          return false;
      }
    },
    onChangeManualControl() {
      this.$store.dispatch('RecreateStuffToEatNutritionFacts', {
        id: this.id,
        type: this.entityType,
      });
    },
  },
  created() {
    this.fetchDishData();
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatContents', { id: this.id });
  },
  watch: {
    id() {
      this.fetchDishData();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';
.section-nutrition-information {
  height: 100vh;
  overflow-y: auto;
  background-color: $nutrition-facts-orange-light-bg;
  @supports (-moz-appearance: none) {
    height: calc(100vh - 60px);
  }
}

.section-manually {
  width: 100%;
  // padding: 1em 0.75em;
  padding: 1em;
  border-bottom: 2px solid #dbe2ef;
}

.section-nutrition-facts {
  width: 100%;
  padding: 0 0.75em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/contents/page-stuff-to-eat-contents.vue